import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  Col,
  Container,
  Input,
  InputGroup,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Link, useNavigate } from "react-router-dom";
import PageService from "../../../services/KangarooServices/PageService";
import moment from "moment/moment";
import toast from "react-hot-toast";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { Triangle } from "react-loader-spinner";
// import blog from "../../../assets/images/file.png";
import {
  imageBaseApi,
  offshoreUrl,
  onshoreUrl,
} from "../../../utilis/imageHelper.js"; // adjust path as needed
import { getLoggedInUser } from "../../../helpers/fakebackend_helper.js";
import noimage from "../../../assets/kangaroo/noimage.png";
import { RiFileCopyLine } from "react-icons/ri";

const PageList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [pageSize, setPageSize] = useState(12);
  const [filters, setFilters] = useState({ search: "", status: "" });
  const [debouncedFilters, setDebouncedFilters] = useState(filters);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const authUser = getLoggedInUser();
  const isDevelopment = process.env.NODE_ENV === "development";
  const isProduction = process.env.NODE_ENV === "production";

  const isSuperAdmin = authUser.roles[0].includes("SuperAdmin");
  const isOnshoreAdmin = authUser.roles[0].includes("OnshoreAdmin");
  const isOffshoreAdmin = authUser.roles.includes("OffshoreAdmin");

  const isOnshorePage = isOnshoreAdmin ? true : isOffshoreAdmin ? false : null;
  const handleFilterChange = (e) => {
    setFilters((prev) => ({ ...prev, search: e.target.value }));
  };
  const fetchPage = async (
    page = 1,
    size = pageSize,
    currentFilters = debouncedFilters,
  ) => {
    setIsLoading(true);
    try {
      const response = await PageService.getList({
        ...currentFilters,
        page,
        pageSize: size,
        isOnshorePage: isOnshorePage,
      });

      setData(response.items);
      setTotalRows(response.totalCount); //Total Rows
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedFilters(filters);
      setCurrentPage(1);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [filters]);

  useEffect(() => {
    fetchPage(currentPage, pageSize);
  }, [currentPage, pageSize, debouncedFilters]);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await PageService.delete(selectedDeleteItem.id);
        fetchPage(currentPage, pageSize);
        toast.success("Page deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  // Pagination controls
  const totalPages = Math.ceil(totalRows / pageSize);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };
  console.log(data);
  const handleCopy = async (previewUrl) => {
    try {
      await navigator.clipboard.writeText(previewUrl);
      toast.success("Link copied to clipboard!");
    } catch (err) {
      toast.error("Failed to copy link");
    }
  };
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Pages" pageTitle="Content Management" />
        <Row className="mb-2">
          <Col lg={6} className="d-flex  mb-2">
            <InputGroup className="w-auto">
              <Input
                placeholder="Search..."
                value={filters.search}
                onChange={handleFilterChange}
              />
            </InputGroup>
          </Col>
          <Col
            md={4}
            xs={12}
            lg={6}
            className="d-flex justify-content-end align-items-end mb-2"
          >
            <Button
              className="btn btn-success"
              onClick={() => navigate("/pages/create")}
            >
              + Create Page
            </Button>
          </Col>
        </Row>
        {isLoading ? (
          <div className="my-3 d-flex justify-content-center align-items-center">
            <Triangle height="100" width="100" color="#556ee6" />
          </div>
        ) : (
          <>
            <Row xs="1" md="2" lg="4" className="g-3">
              {data?.map((item) => {
                const baseUrl = item?.isOnshorePage ? onshoreUrl : offshoreUrl;

                const extraPath = item?.isOnshorePage
                  ? "/kevsintelligence"
                  : "/other-product-services";

                const previewUrl = `${baseUrl}${extraPath}/${item?.slug || ""}`;
                const copyUrl = `${extraPath}/${item?.slug || ""}`;

                return (
                  <Col lg={4} key={item.id}>
                    <Card
                      className="h-100 shadow-sm border-0 rounded-4 small-card cursor-pointer"
                      onClick={() => navigate(`/pages-list/${item?.slug}`)}
                    >
                      {/* your existing Card content */}
                      <div className="logo-wrapper">
                        <CardImg
                          src={
                            item?.featuredMedia?.url
                              ? `${imageBaseApi}${item.featuredMedia.url}`
                              : noimage
                          }
                          alt="thumb"
                          className="img-fluid w-100 h-100 object-fit-contain"
                        />
                      </div>
                      <CardBody className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <div className="d-flex align-items-center  text-muted small">
                            {moment(item.createdAt).format(
                              "YYYY-MM-DD hh:mm A",
                            )}
                          </div>
                          <div className="d-flex justify-content-between align-items-center ">
                            <Badge
                              color={
                                item.status?.toLowerCase() === "draft"
                                  ? "info" // blue
                                  : "success" // green
                              }
                            >
                              {item.status}
                            </Badge>
                          </div>
                        </div>
                        <small className="text-muted fst-italic">
                          {item.slug || "-"}
                        </small>
                        <h5 className="pt-2 mb-1 fw-semibold text-dark">
                          {item.title}
                        </h5>
                        {item.subtitle && (
                          <p className="text-muted  small">{item.subtitle}</p>
                        )}

                        {/* <div className="d-flex align-items-center  text-muted small">
                          <i className="bx bx-calendar me-1"></i>
                          {moment(item.createdAt).format("YYYY-MM-DD hh:mm A")}
                        </div> */}
                      </CardBody>
                      <CardFooter className="bg-transparent border-0 pt-0 pb-3 px-3">
                        <div className="d-flex justify-content-between align-items-center">
                          {/* <span
                            className="text-primary small fw-semibold cursor-pointer"
                            onClick={() =>
                              navigate(`/pages-list/${item?.slug}`)
                            }
                          >
                            Read More →
                          </span> */}
                          <Button
                            size="sm"
                            color="light"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCopy(isDevelopment ? copyUrl : previewUrl);
                            }}
                            className="d-flex align-items-center gap-1"
                            title="Copy Url"
                          >
                            <RiFileCopyLine size={16} />
                          </Button>
                          <div className="d-flex gap-2">
                            {/* ✅ Preview Button */}
                            <a
                              href={previewUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <button
                                className="btn btn-sm btn-info"
                                title="Preview"
                              >
                                <i className="ri-eye-line"></i>
                              </button>
                            </a>

                            <Button
                              size="sm"
                              color="warning"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/pages/update/${item.slug}`);
                              }}
                            >
                              <i className="ri-edit-line"></i>
                            </Button>

                            <Button
                              size="sm"
                              color="danger"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteClick(item);
                              }}
                            >
                              <i className="ri-delete-bin-5-line"></i>
                            </Button>
                          </div>
                        </div>
                      </CardFooter>
                    </Card>
                  </Col>
                );
              })}
            </Row>

            {/* Pagination */}
            {totalPages > 0 && (
              <div className="d-flex justify-content-center my-4 sticky-bottom">
                <Pagination className="mb-0">
                  <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink
                      previous
                      onClick={() => handlePageChange(currentPage - 1)}
                    />
                  </PaginationItem>

                  {Array.from({ length: Math.min(7, totalPages) }, (_, i) => {
                    const page = currentPage <= 4 ? i + 1 : i + currentPage - 4;
                    if (page > totalPages) return null;
                    return (
                      <PaginationItem key={page} active={currentPage === page}>
                        <PaginationLink onClick={() => setCurrentPage(page)}>
                          {page}
                        </PaginationLink>
                      </PaginationItem>
                    );
                  })}

                  <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink
                      next
                      onClick={() => handlePageChange(currentPage + 1)}
                    />
                  </PaginationItem>
                </Pagination>
              </div>
            )}
          </>
        )}
      </div>

      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </Container>
  );
};

export default PageList;
